import angular from 'angular';
/**
 * A set of common utility methods the app may need.
 * @ngesdoc service
 * @ngname appUtils
 * @ngmodule common
 */
class AppUtils {
  /**
   * @param {Window} $window For the methods that handle window events.
   */
  constructor($window) {
    'ngInject';

    /**
     * A local reference for the browser window.
     * @type {[type]}
     */
    this.$window = $window;
  }
  /**
   * Attach an event listener to the browser window.
   * @param {Array|String} events The name or names of the events.
   * @param {Function}     fn     The listener function that will be executed when the event or
   *                              events are triggered.
   * @return {Function} An unsubscribe function to remove the listener(s).
   */
  attachWindowEvents(events, fn) {
    const list = angular.isString(events) ? [events] : events;
    list.forEach((event) => this.$window.addEventListener(event, fn));
    return () => this.detachWindowEvents(list, fn);
  }
  /**
   * Transforms a CamelCase string into dash format.
   * @param {string} str The string to transform
   * @return {string}
   */
  camelCaseToDash(str) {
    const firstLetter = str.substr(0, 1).toLowerCase();
    const rest = str.substr(1);
    const newStr = `${firstLetter}${rest}`;
    return newStr.replace(/([A-Z])/g, ($1) => {
      const letter = $1.toLowerCase();
      return `-${letter}`;
    });
  }
  /**
   * Remove listener from a browser window event.
   * @param {Array|String} events The name or names of the events.
   * @param {Function}     fn     The lsitener function to remove.
   */
  detachWindowEvents(events, fn) {
    const list = angular.isString(events) ? [events] : events;
    list.forEach((event) => this.$window.removeEventListener(event, fn));
  }
  /**
   * Generates a random hash.
   * @return {string}
   */
  randomHash() {
    const radix = 36;
    const cutFrom = 2;
    const cutTo = 16;
    return Math.random().toString(radix).substr(cutFrom, cutTo);
  }
  /**
   * Generates a timestamps using seconds.
   * @return {Number}
   */
  timestamp() {
    const millisecondsInASecond = 1000;
    return Math.floor(Date.now() / millisecondsInASecond);
  }
}

export default AppUtils;
